import React, { useMemo } from 'react'
import { useState } from 'react'
import Modal from 'react-modal';

/**
 * Regex tirada do stackoverflow
 * Link: https://stackoverflow.com/questions/161738/what-is-the-best-regular-expression-to-check-if-a-string-is-a-valid-url
 */

const urlRegex = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        display: 'flex',
        background: 'none',
        boxShadow: 'none',
        zIndex: '999',
        backgroundColor: "rgba(255, 255, 255, 0.9);"
    }
};

const customBoxTerms = {
    padding: '22px'
};

export const TermsField = ({ checked, onChange, show = false, terms }) => {
    const [showModal, setShowModal] = useState(false)
    const isTermsLink = useMemo(() => urlRegex.test(terms), terms)
    if (!show) return ""
    const linkModal = <span className="text-pink" style={{ cursor: 'pointer' }} onClick={() => setShowModal(true)}>termos de uso</span>
    const linkFile = <a className="text-pink" target="_blank" rel="noreferrer" href={terms}>termos de uso</a>

    return (
        <React.Fragment>
            <div className='terms'>
                <input
                    style={{ display: "inline-block" }}
                    type="checkbox"
                    checked={checked}
                    onChange={onChange}
                /> Concordo com os {isTermsLink ? linkFile : linkModal}
            </div>
            <Modal
                isOpen={showModal}
                onRequestClose={() => setShowModal(false)}
                style={customStyles}
                contentLabel="Cadastre-se">
                <div className="box-modal">
                    <div className="Grid Grid--gutter Grid-column">
                        <div className="Grid-cell">
                            <div className="close-modal">
                                <p className="float-right" onClick={() => setShowModal(false)}>
                                    Fechar X
                                </p>
                            </div>
                        </div>
                        <div className="Grid-cell">
                            <div style={customBoxTerms} className="modal-content content-terms">
                                <h4>Termos de Uso</h4>
                                <div className='text'>
                                    {terms}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </React.Fragment>
    )
}
